import { useMemo } from 'react';
import { useAppSelector } from 'src/utils/Hooks/typedHooks';

/**
 * Custom hook to get processed current and future week IDs
 *
 * For Beacon: Returns unique week IDs sorted in descending order (largest/most recent first)
 * For Atlas: Returns empty array (not yet supported)
 *
 * @returns {string[]} Array of unique week IDs or empty array for Atlas
 * @TODO: Implement Atlas support for week ID retrieval
 */
export const useCurrentAndFutureWeekId = (): string[] => {
  const allWeekIdsByRetailerId = useAppSelector((state) => state.allWeekIdsByRetailerId);

  const processedWeekIds = useMemo(() => {
    // Extract all week IDs from all retailers, deduplicate, and sort descending
    const weekIds = [...new Set(Object.values(allWeekIdsByRetailerId).flat().map(String))].sort(
      (a, b) => parseInt(b, 10) - parseInt(a, 10)
    ); // Sort descending (largest first)

    return weekIds;
  }, [allWeekIdsByRetailerId]);

  return processedWeekIds;
};

export default useCurrentAndFutureWeekId;
